export const RECORDING_SESSION_TYPES = [
  { value: 'RECORDING_SESSION_REMOTE', label: 'Remote' },
  { value: 'RECORDING_SESSION_HYBRID', label: 'Hybrid' },
  { value: 'RECORDING_SESSION_IN_PERSON', label: 'In Person' },
] as const;

export type TRecordingSessionType = (typeof RECORDING_SESSION_TYPES)[number]['value'];
